// Centralized content for Upper Crest Image
// All images served from /public/images (local, no external CDN dependency)
export const LOGO = {
  whiteOnBlack: "/images/logo-white.png",
  threeDimensional: "/images/logo-3d.png",
  gold: "/images/logo-gold.png",
  blackOnWhite: "/images/logo-black.png",
};

// One curated background image per tagline (7-second rotation)
export const HERO_SLIDES = [
  { tagline: "Elevating Vision Into Influence.", image: "/images/hero-1.jpg" },
  { tagline: "Where Vision Meets Prestige.",     image: "/images/hero-2.jpg" },
  { tagline: "Built for Brands Ready to Lead.",  image: "/images/hero-3.jpg" },
  { tagline: "Positioning the Exceptional.",     image: "/images/hero-4.jpg" },
  { tagline: "Your Next Move Toward the Top.",   image: "/images/hero-5.jpg" },
];

// Hero collage thumbnails
export const HERO_COLLAGE = [
  "/images/collage-1.jpg",
  "/images/collage-2.jpg",
  "/images/collage-3.jpg",
  "/images/collage-4.jpg",
];

// Portfolio / general editorial imagery
export const PORTFOLIO_IMAGES = [
  "/images/portfolio-1.jpg",
  "/images/portfolio-2.jpg",
  "/images/portfolio-3.jpg",
  "/images/portfolio-4.jpg",
  "/images/portfolio-5.jpg",
  "/images/portfolio-6.jpg",
];

// Legacy aliases
export const HERO_IMAGES = HERO_SLIDES.map((s) => s.image);
export const TAGLINES = HERO_SLIDES.map((s) => s.tagline);

export const PARTNER_MARQUEE = [
  "Hampton Roads Magazine", "Norfolk Chamber", "Coastal Productions", "Atlas Influencer Co.",
  "Crowned Campaigns", "Pinnacle Pulpit", "Sovereign Sound", "Aurum Studios",
  "Hampton Roads Magazine", "Norfolk Chamber", "Coastal Productions", "Atlas Influencer Co.",
];

export const SERVICES = [
  { id: "branding", title: "Branding Consulting", description: "Identity systems, narrative frameworks, and visual language that command attention from the boardroom to the campaign trail." },
  { id: "marketing", title: "Marketing Consulting", description: "Editorial-grade marketing strategy crafted for influence — equipped to move audiences and unlock new tiers of growth." },
  { id: "creative-direction", title: "Creative Direction", description: "Holistic art direction across photography, video, and editorial — tuned for prestige and resonance." },
  { id: "campaign", title: "Campaign Consulting & Management", description: "End-to-end campaign architecture, message control, and execution for political and brand campaigns." },
  { id: "production", title: "Production Management", description: "Television, film, and brand-led productions managed with cinematic precision and editorial taste." },
  { id: "project", title: "Project Management", description: "White-glove project orchestration for executive teams, founders, and high-profile principals." },
  { id: "conference", title: "Conference Management", description: "Full-scale conference design, stage production, sponsorship, and attendee experience." },
  { id: "event", title: "Event Planning & Styling", description: "Editorial event design — galas, fundraisers, brand activations, and intimate gatherings." },
  { id: "graphic-design", title: "Graphic Design Coordination", description: "Designer sourcing, asset oversight, and creative QA across decks, collateral, and campaign systems." },
  { id: "website", title: "Website Consulting & Development", description: "Strategy, copy, and build coordination for websites that match the caliber of the principal." },
  { id: "public-image", title: "Public Image Consulting", description: "For executives, influencers, pastors, and public-facing professionals — image, message, and presence elevated." },
  { id: "workshops", title: "Corporate Workshops & Training", description: "Branded leadership, communication, and presence training for executive teams." },
];

export const PACKAGES = [
  {
    name: "Signature Consultation",
    price: "Starting at $1,500",
    cadence: "Single engagement",
    description: "An exclusive deep-dive into your brand position, messaging, and immediate growth levers.",
    features: ["90-minute strategy session", "Audit of current brand position", "12-page positioning brief", "Two follow-up touchpoints"],
  },
  {
    name: "Influence Retainer",
    price: "Starting at $4,500 / mo",
    cadence: "3-month minimum",
    description: "Ongoing creative direction and brand stewardship for principals on the rise.",
    features: ["Bi-weekly strategy sessions", "Creative direction across channels", "Media-ready talking points", "Direct-line concierge access"],
    featured: true,
  },
  {
    name: "Production & Campaign",
    price: "Custom",
    cadence: "Per engagement",
    description: "Full production and campaign management for film, television, political, and brand initiatives.",
    features: ["Full project orchestration", "Vendor & talent management", "Editorial creative direction", "Executive reporting"],
  },
];

export const COMPANY = {
  name: "Upper Crest Image, LLC",
  short: "Upper Crest Image",
  email: "contact@ucimage.com",
  instagram: "https://instagram.com/UCimage2",
  facebook: "https://www.facebook.com/ucimage2",
  tiktok: "https://www.tiktok.com/@ucimage",
  region: "Hampton Roads, VA — Nationwide engagements",
};
